export default {
  // Get the basket.id
  id(state) {
    return state.id
  },

  // Get the full Basket payload
  payload(state) {
    return state
  },

  // Get the Upsell Basket data
  upsell(state) {
    return state.upsell
  },

  // TODO TO REMOVE
  // Get the numOfItems data
  numOfItems(state) {
    return state.numOfItems
  },

  // Get the num_of_items data
  num_of_items(state) {
    return state.num_of_items
  },

  // Get the BasketItem List
  items(state) {
    return state.items
  },

  // Get the BasketItem by ID
  item: state => id => {
    return state.items.find(i => i.id === id)
  },

  // get all up_sell products present in the basket
  items_up_sell(state) {
    const uniqueUpSellProducts = []

    const seenIds = new Set()

    state.items.forEach(item => {
      const upSellProducts = item.up_sell || []
      upSellProducts.forEach(product => {
        const { sku, enabled } = product
        console.log(`items_up_sell sku=${sku} enabled=${enabled}`)
        if (enabled && !seenIds.has(sku)) {
          seenIds.add(sku)
          uniqueUpSellProducts.push(product)
        }
      })
    })

    return uniqueUpSellProducts
  },

  // get all cross_sell products present in the basket
  items_cross_sell(state) {
    const uniqueCrossSellProducts = []

    const seenIds = new Set()

    state.items.forEach(item => {
      const crossSellProducts = item.cross_sell || []
      crossSellProducts.forEach(product => {
        const { sku, enabled } = product
        if (!enabled) {
          return
        }

        console.log(`items_cross_sell sku=${sku} enabled=${enabled}`)
        const isAlreadyPresentInBasket = state?.items?.find(e => e?.offer?.sku === sku)
        if (!isAlreadyPresentInBasket && !seenIds.has(sku)) {
          seenIds.add(sku)
          uniqueCrossSellProducts.push(product)
          // uniqueCrossSellProducts.push(product)
        }
      })
    })

    return uniqueCrossSellProducts
  }
}
